import { openInBrowser } from "./functions/open-in-browser.function";

export { openInBrowser } from "./functions/open-in-browser.function";
export default openInBrowser;
